import React from 'react'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  List,
  ListItem,
  ListItemText,
  Typography,
} from '@mui/material'
import { SyncHistoryEntry } from '@/lib/db/indexed-db'

interface Props {
  open: boolean
  history: SyncHistoryEntry[]
  onClose: () => void
}

const SyncHistoryDialog: React.FC<Props> = ({ open, history, onClose }) => (
  <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
    <DialogTitle>Sync History</DialogTitle>
    <DialogContent dividers>
      {history.length === 0 ? (
        <Typography variant="body2" color="text.secondary">
          No sync runs recorded yet.
        </Typography>
      ) : (
        <List disablePadding>
          {history.map((entry) => (
            <ListItem key={entry.id} divider>
              <ListItemText
                primary={new Date(entry.timestamp).toLocaleString()}
                secondary={`Synced: ${entry.itemsSynced} · Failed: ${entry.itemsFailed} · Conflicts: ${entry.conflicts} · ${entry.durationMs}ms`}
              />
            </ListItem>
          ))}
        </List>
      )}
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>Close</Button>
    </DialogActions>
  </Dialog>
)

export default SyncHistoryDialog
